import { useContext } from "react";
import { SessionInProgressContext } from "./SessionInProgressContext";

function useSessionInProgress() {
  return useContext(SessionInProgressContext);
}

export { useSessionInProgress };